import { useAuth0 } from '@auth0/auth0-react';
import Clarity from '@microsoft/clarity';
import { useAtom } from 'jotai';
import React, { useEffect, useState } from 'react';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import { getRoles } from './api/user';
import Configuration from './pages/configuration/configuration';
import LoginPage from './pages/login-page/loginPage';
import OrderConfirmation from './pages/order-confirmation/orderConfirmation';
import ProjectDetails from './pages/project-details/projectDetails';
import ProjectOverviewClient from './pages/project-overview-client/projectOverviewClient';
import ProjectOverviewDesigner from './pages/project-overview-designer/projectOverviewDesigner';
import ProjectSteps from './pages/project-steps/projectSteps';
import Registration from './pages/registration/registration';
import rolesAtom from './store/atoms';

Clarity.init('tr1cdr4w9j');

function App() {
  const [wizardStep, setWizardStep] = useState(0);
  const { isAuthenticated, getAccessTokenSilently, isLoading, user } = useAuth0();
  const [roles, setRoles] = useAtom(rolesAtom);

  const handleChangeStep = (step) => {
    setWizardStep(step);
  };

  useEffect(() => {
    const getRolesFromBackend = async () => {
      try {
        const token = await getAccessTokenSilently();
        const updatedRoles = await getRoles(token, user.email);
        if (updatedRoles) {
          setRoles(updatedRoles);
        }
      } catch (e) {
        console.error('Error while fetching roles', e);
      }
    };
    if (isAuthenticated) {
      getRolesFromBackend();
    }
  }, [isAuthenticated, getAccessTokenSilently, user?.email]);

  return (
    <div>
      <div className="app">
        <Router>
          <Routes>
            {!isAuthenticated && !isLoading && !user && (
              <Route path="/login" element={<LoginPage />} />
            )}
            {isAuthenticated && user && (
              <>
                {roles.includes('Client') && <Route path="/" element={<ProjectOverviewClient />} />}
                {roles.includes('Designer') && (
                  <Route path="/" element={<ProjectOverviewDesigner />} />
                )}
                {roles.includes('Admin') && <Route path="/" element={<Configuration />} />}
                <Route path="/project/:id" element={<ProjectDetails />} />
                {roles.includes('Admin') && (
                  <Route path="/configuration" element={<Configuration />} />
                )}
              </>
            )}
            {!isAuthenticated && !isLoading && (
              <>
                <Route
                  path="/"
                  element={
                    <ProjectSteps wizardStep={wizardStep} changeWizardStep={handleChangeStep} />
                  }
                />
                <Route
                  path="/new-project"
                  element={
                    <ProjectSteps wizardStep={wizardStep} changeWizardStep={handleChangeStep} />
                  }
                />
                <Route
                  path="/new-project/:id"
                  element={
                    <ProjectSteps wizardStep={wizardStep} changeWizardStep={handleChangeStep} />
                  }
                />
                <Route path="/registration/:id" element={<Registration />} />
              </>
            )}
            <Route path="/package-order-completed" element={<OrderConfirmation />} />
          </Routes>
        </Router>
      </div>
    </div>
  );
}

export default App;
